/* unplugin-vue-components disabled */import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-32df1cb6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  id: "configurationSidebar",
  class: "hidden md:flex flex-col w-[72px] h-full min-h-[485px] justify-between text-white bg-backgroundSidebar z-20"
};
const _hoisted_2 = {
  class: "flex flex-col items-center justify-center add-buttons"
};
const _hoisted_3 = {
  class: "flex flex-col items-center mb-3"
};
import { useConfiguratorStore } from "@/stores/configurator";
// import { useCreateEditorObject } from '@/composables/2dEditor/useCreateEditorObject';
// import { useWindowSize } from '@vueuse/core';

import SidebarButton from "@/components/configurator/sidebar/SidebarButton";
import LightDarkToggle from "@/components/configurator/sidebar/LightDarkToggle";

// const { width: windowWidth } = useWindowSize()

// const { t } = useI18n();

// const { $eventBus } = useNuxtApp();

export default {
  __name: 'ConfiguratorSidebar',
  setup(__props) {
    const configuratorStore = useConfiguratorStore();
    const {
      showTextDrawer,
      showImagesDrawer,
      showBackgroundDrawer,
      showShapesDrawer,
      showSettingsDrawer
      // mobileBreakpoint,
    } = configuratorStore;
    const {
      activeDrawerComponentIndex
    } = storeToRefs(configuratorStore);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(SidebarButton), {
        icon: "textarea",
        name: _ctx.$t('configurator.text'),
        isActive: _unref(activeDrawerComponentIndex) === 1,
        onClick: _unref(showTextDrawer)
      }, null, 8, ["name", "isActive", "onClick"]), _createVNode(_unref(SidebarButton), {
        icon: "images",
        name: _ctx.$t('configurator.images'),
        isActive: _unref(activeDrawerComponentIndex) === 2,
        onClick: _unref(showImagesDrawer)
      }, null, 8, ["name", "isActive", "onClick"]), _createVNode(_unref(SidebarButton), {
        icon: "hexagon",
        name: _ctx.$t('configurator.background'),
        isActive: _unref(activeDrawerComponentIndex) === 3,
        onClick: _unref(showBackgroundDrawer)
      }, null, 8, ["name", "isActive", "onClick"]), _createVNode(_unref(SidebarButton), {
        icon: "triangle",
        name: _ctx.$t('configurator.shapes'),
        isActive: _unref(activeDrawerComponentIndex) === 4,
        onClick: _unref(showShapesDrawer)
      }, null, 8, ["name", "isActive", "onClick"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, [_createVNode(_unref(SidebarButton), {
        icon: "settings",
        name: _ctx.$t('configurator.settings'),
        class: "mb-3",
        onClick: _unref(showSettingsDrawer)
      }, null, 8, ["name", "onClick"])]), _createElementVNode("div", null, [_createVNode(_unref(LightDarkToggle))])])]);
    };
  }
};